/*
 * @Author: Suroc
 * @Date: 2024-07-19 10:40:46
 * @LastEditTime: 2024-12-27 15:29:29
 * @Description: 全局合约实例化
*/
import Web3 from 'web3'
import $Tool from '@/utils/tool.js'
import {
  contractABI, contractAddress,
  tokenAuthorizeContract,
  tokenAuthorizeContractABI,
  usdtAuthorizeContract,
  usdtAuthorizeContractABI
} from '@/contract/solidity'

// 定义全局变量
window.web3 = null // 全局web3对象
window.contract = null // 全局合约对象
window.Token = null // FLST合约对象
window.USDTToken = null // USTD合约对象
window.ContractAddress = contractAddress
window.ContractABI = contractABI
/* window.TokenContractAddress = tokenAuthorizeContract
window.TokenContractABI = tokenAuthorizeContractABI
window.usdtContractAddress = usdtAuthorizeContract
window.usdtContractABI = usdtAuthorizeContractABI */

/**
 * @description 初始化合约
 */
export const initContract = async () => {
  if (window.ethereum) {
    window.web3 = new Web3(window.ethereum)
    try {
    /*   window.contract = new window.web3.eth.Contract(ContractABI, ContractAddress)
      window.Token = new window.web3.eth.Contract(TokenContractABI, TokenContractAddress)
      window.USDTToken = new window.web3.eth.Contract(usdtContractABI, usdtContractAddress) */
      console.log('合约初始化成功')
    } catch (error) {
      $Tool.openMessage('合约初始化异常', 'error')
    }
   
  } else {
    console.error('未检测到以太坊提供商。')
  }
}


